import type { ReactNode } from "react";

import { HaNErrorBoundary } from "../../shared/HaNErrorBoundary";

// The sidebar's list on wide screens; on phones it fills the page in the list view.
export const HaNList = ({ children }: { children: ReactNode }) => {
  return (
    <div className="relative col-start-1 row-start-4 flex min-h-0 flex-col overflow-y-auto border-r bg-white max-sm:row-start-5 max-sm:border-r-0 max-sm:group-data-[mobile-view=map]/han:hidden">
      <HaNErrorBoundary area="List">{children}</HaNErrorBoundary>
    </div>
  );
};
